<template>
	<div>
		<detail-nav title="合伙人详情" @navigateBack="gpNavigateback"></detail-nav>

		<el-row>
			<el-col :span="24">
				<div id="layer1" class="gp-layer-body margin-bottom-15">
					<div class="gp-row gp-row-center padding-bottom-0">
						<div class="gp-row-label"></div>
						<div class="gp-row-title">基础信息</div>
					</div>
					<div class="gp-section gp-flex-1 padding-top-0 padding-bottom-30 padding-left-0 padding-right-20">
						<el-col :span="11">
							<div class="group_info">
								<div class="group_logo">
									<img :src="info.partner_head" />
								</div>
								<div class="group_baseinfo">
									<div class="partner_name max-line-1" style="-webkit-box-orient: vertical;" :title="info.partner_nick">
										{{info.partner_nick}}</div>
									<div class="group_name max-line-1" style="-webkit-box-orient: vertical;">
										所在社群：{{info.group_name}}</div>
									<div class="owner_name max-line-1" style="-webkit-box-orient: vertical;" :title="info.owner_name">
										<span>经营</span>者：{{info.owner_name}}
									</div>
								</div>
							</div>
						</el-col>
						<el-col :span="13">
							<div class="sell_detail">
								<div class="sell_detail_option">
									<div class="sell_detail_value">{{info.sell_order}}</div>
									<div class="sell_detail_title">分销订单（单）</div>
								</div>
								<div class="sell_detail_option">
									<div class="sell_detail_value">{{info.total_commission}}</div>
									<div class="sell_detail_title">累计佣金（元）</div>
								</div>
								<div class="sell_detail_option">
									<div class="sell_detail_value">{{sell_products.count}}</div>
									<div class="sell_detail_title">分销商品（个）</div>
								</div>
							</div>
						</el-col>
					</div>
				</div>
			</el-col>
		</el-row>

		<el-row>
			<el-col :span="24">
				<div id="layer2" class="gp-layer-body">
					<div class="gp-row gp-row-center padding-bottom-0">
						<div class="gp-row-label"></div>
						<div class="gp-row-title">推广商品（{{sell_products.count}}）</div>
					</div>
					<template v-if="sell_products.count > 0">
						<div class="gp-section padding-top-20">
							<el-row :gutter="12">
								<el-col :span="8" v-for="(item, index) in sell_products.list">
									<div class="product_item margin-bottom-12">
										<div class="product_cover">
											<img :src="item.bp_cover" />
											<template v-if="item.bp_status">
												<span class="orange">推广中</span>
											</template>
											<template v-else>
												<span class="gray">未推广</span>
											</template>
										</div>
										<div class="product_info">
											<div class="product_name max-line-2" style="-webkit-box-orient: vertical;"
												:title="item.title">{{item.title}}</div>
											<div class="product_sell_info margin-top-10">
												<div class="product_price">¥{{item.price}}</div>
												<div class="product_sell_num">已推广：{{item.sell_num}}件</div>
											</div>
										</div>
									</div>
								</el-col>
							</el-row>
						</div>
						<!-- 分页器 -->
						<div class="gp-pagination">
							<el-pagination @current-change="handleCurrentChange" background
								layout="total, prev, pager, next, jumper" :page-size="pageSize" :current-page.sync="currentPage"
								:total="sell_products.count">
							</el-pagination>
						</div>
					</template>
					<template v-else>
						<div class="asd">
							<img class="asd_img" src="../../assets/img/partner/empty-product.png" />
							<div class="asd_txt">合伙人暂时还没有推广商品</div>
						</div>
					</template>
				</div>
			</el-col>
		</el-row>
	</div>
</template>

<script>
	import {
		getPartnerDetail,
		getSellProducts
	} from '../../api/partner';
	import detailNav from '@/components/detail-nav.vue';
	export default {
		data() {
			return {
				id: 0,
				info: {},
				sell_products: {
					count: 0,
					list: []
				},
				pageSize: 6,
				currentPage: 1,
			};
		},
		components: {
			detailNav
		},
		mounted() {
			document.getElementsByClassName("father-main")[0].scrollTop = 0;

			var query = this.$route.query;
			if (query && query.id) {
				this.id = Number(query.id);
				this.getDetail();
				this.getSellProductList();
			}
			// 监听浏览器返回
			if (window.history && window.history.pushState) {
				// 向历史记录中插入了当前页
				history.pushState(null, null, document.URL);
				window.addEventListener('popstate', this.gpNavigateback, false);
			}
		},
		destroyed() {
			window.removeEventListener('popstate', this.gpNavigateback, false);
		},
		methods: {
			gpNavigateback() {
				localStorage.setItem('keypage', this.list_page);
				this.$router.go(-1);
			},
			handleCurrentChange(value) {
				this.currentPage = value;
				this.getSellProductList();
			},
			getDetail() {
				if (this.id) {
					getPartnerDetail({
						partner_id: this.id
					}).then(res => {
						if (res.code == 0) {
							this.info = res.data;
						} else {
							this.$message.error(res.message);
						}
					})
				}
			},
			getSellProductList() {
				getSellProducts({
					partner_id: this.id,
					pagesize: this.pageSize,
					current: this.currentPage
				}).then(res => {
					if (res.code == 0) {
						this.sell_products = res.data;
					}
				})
			}
		}
	};
</script>

<style scoped>
	/* ---------------- */
	.asd {
		width: 100%;
		padding: 60px 0;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
	}
	.asd_img {
		width: 162px;
		height: 140px;
	}
	.asd_txt {
		margin-top: 17px;
		font-size: 12px;
		font-family: PingFang-SC-Medium, PingFang-SC;
		font-weight: 500;
		color: #999999;
		line-height: 17px;
	}
	
	#layer2 {
		min-height: 400px;
	}

	.gp-flex-1 {
		display: flex;
		align-items: center;
		justify-content: space-between;
	}

	.group_info {
		display: flex;
		align-items: center;
	}

	.group_logo {
		position: relative;
		margin-left: 30px;
		width: 60px;
		min-width: 60px;
		height: 60px;
	}

	.group_logo img {
		width: 100%;
		height: 100%;
		border-radius: 50%;
	}

	.group_logo span {
		position: absolute;
		bottom: 0;
		left: 0;
	}

	.group_baseinfo {
		margin-left: 10px;
		margin-right: 25px;
		font-size: 18px;
		font-family: PingFang-SC-Medium, PingFang-SC;
		font-weight: 500;
		color: #333333;
		line-height: 25px;
	}

	.partner_name {
		font-size: 18px;
		font-family: PingFang-SC-Medium, PingFang-SC;
		font-weight: 500;
		color: #333333;
		line-height: 25px;
	}

	.group_name {
		margin-top: 10px;
		margin-bottom: 5px;
	}

	.group_name,
	.owner_name {
		font-size: 14px;
		font-family: PingFang-SC-Medium, PingFang-SC;
		font-weight: 500;
		color: #666666;
		line-height: 20px;
	}

	.owner_name span {
		letter-spacing: 7px;
	}

	.sell_detail {
		width: 100%;
		height: 107px;
		display: flex;
		align-items: center;
		background: #FFFFFF;
		border-radius: 8px;
		border: 1px solid #EEEEEE;
	}

	.sell_detail_option {
		width: 33%;
		height: 100%;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		border-right: 1px solid #EEEEEE;
	}

	.sell_detail_option:last-child {
		border-right: 0;
	}

	.sell_detail_value {
		font-size: 26px;
		font-family: PingFang-SC-Bold, PingFang-SC;
		font-weight: bold;
		color: #409EFF;
		line-height: 40px;
	}

	.sell_detail_title {
		font-size: 14px;
		font-family: PingFang-SC-Medium, PingFang-SC;
		font-weight: 500;
		color: #666666;
		line-height: 22px;
	}

	/* ---------------- */

	.gp-layer-body {
		background: #FFFFFF;
		border-radius: 4px;
		border-top: 1px solid #EEEEEE;
	}

	.gp-section {
		padding: 10px;
	}

	.gp-row {
		width: 100%;
		padding: 20px 0 10px 0;
		display: flex;
		align-items: flex-start;
	}

	.gp-row-center {
		align-items: center;
	}

	.gp-row-label {
		width: 3px;
		height: 25px;
		margin-right: 15px;
		background: #409EFF;
	}

	.gp-row-title {
		font-size: 18px;
		font-family: PingFang-SC-Medium, PingFang-SC;
		font-weight: bold;
		color: #333333;
		line-height: 30px;
	}

	.gp-onlyline {
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
	}

	.product_item {
		padding: 11px;
		display: flex;
		align-items: center;
		background: #FFFFFF;
		border-radius: 4px;
		border: 1px solid #DCDFE6;
	}

	.product_cover {
		position: relative;
		width: 80px;
		min-width: 80px;
		height: 80px;
		border-radius: 4px;
	}

	.product_cover img {
		width: 100%;
		height: 100%;
		object-fit: cover;
		border-radius: 4px;
	}

	.product_cover span {
		width: 100%;
		height: 16px;
		display: block;
		text-align: center;
		position: absolute;
		bottom: 0;
		left: 0;
	}

	.orange {
		font-size: 12px;
		font-family: PingFang-SC-Medium, PingFang-SC;
		font-weight: 500;
		color: #FFFFFF;
		line-height: 14px;
		background: #FF8700;
		border-radius: 0px 0px 4px 4px;
	}

	.gray {
		font-size: 12px;
		font-family: PingFang-SC-Medium, PingFang-SC;
		font-weight: 500;
		color: #FFFFFF;
		line-height: 14px;
		background: #CCCCCC;
		border-radius: 0px 0px 4px 4px;
	}

	.product_info {
		width: 100%;
		margin-left: 12px;
	}

	.product_name {
		height: 46px;
		font-size: 14px;
		font-family: PingFang-SC-Medium, PingFang-SC;
		font-weight: 500;
		color: #333333;
		line-height: 23px;
	}

	.product_sell_info {
		display: flex;
		align-items: center;
		margin-top: 9px;
		font-size: 12px;
		font-family: PingFang-SC-Medium, PingFang-SC;
		font-weight: 500;
		color: #999999;
		line-height: 17px;
	}

	.product_price {
		font-size: 18px;
		font-family: PingFang-SC-Bold, PingFang-SC;
		font-weight: bold;
		color: #F76B69;
		line-height: 30px;
	}

	.product_sell_num {
		margin-left: 10px;
		font-size: 12px;
		font-family: PingFang-SC-Medium, PingFang-SC;
		font-weight: 500;
		color: #333333;
		line-height: 17px;
	}

	.gp-pagination {
		padding: 35px;
		text-align: center;
		background: #FFFFFF;
	}

	.max-line-1 {
		display: -webkit-box;
		text-overflow: ellipsis;
		overflow: hidden;
		word-break: break-all;
		-webkit-line-clamp: 1;
	}

	.max-line-2 {
		display: -webkit-box;
		text-overflow: ellipsis;
		overflow: hidden;
		word-break: break-all;
		-webkit-line-clamp: 2;
	}

	.margin-top-70 {
		margin-top: 70px;
	}

	.margin-top-10 {
		margin-top: 10px;
	}

	.margin-left-15 {
		margin-left: 15px;
	}

	.margin-bottom-12 {
		margin-bottom: 12px;
	}

	.margin-bottom-15 {
		margin-bottom: 15px;
	}

	.padding-top-0 {
		padding-top: 0;
	}

	.padding-top-15 {
		padding-top: 15px;
	}

	.padding-top-20 {
		padding-top: 20px;
	}

	.padding-left-0 {
		padding-left: 0;
	}

	.padding-left-30 {
		padding-left: 30px;
	}

	.padding-right-20 {
		padding-right: 20px;
	}

	.padding-bottom-15 {
		padding-bottom: 15px;
	}

	.padding-bottom-30 {
		padding-bottom: 30px;
	}
</style>
